export default [

    {
        path: '',
        name: 'fichas-cadastrais',
        component: () => import('@/aplicacao/modulos/fichas-cadastrais/FichasCadastrais'),
        meta: { autenticacao: true },
    },

]
